module.exports = __webpack_public_path__ + "static/img/logo.b2b84f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/logo.png
// module id = BVbT
// module chunks = 1